<template>
	<div class="title">
		<i class="iconfont iconshuxian"></i>
		<span class="main-title"><slot name="mainTitle"></slot></span>
		<span class="second-title"><slot name="secondTitle"></slot></span>
	</div>
</template>

<script>
export default {
	name: 'titles',
	props: {
		title: {
			type: String,
			default: ''
		},
		secondTitle: {
			type: String,
			default: ''
		}
	}
}
</script>

<style scoped lang="less">
.title {
	display: flex;
	.iconfont {
		font-size: 30px;
		color: #009688;
	}
	.main-title {
		font-size: 20px;
		color: #333333;
		padding: 0 15px 0 0;
		margin-left: -12px;
		line-height: 30px;
	}
	.second-title {
		padding-top: 9px;
		font-size: 14px;
	}
	@media print {
		.main-title {
			font-size: 26px;
		}
		.second-title {
			font-size: 18px;
		}
	}
	.look-origin {
		font-size: 13px;
		padding-left: 15px;
		color: rgb(29, 174, 248);
		padding-top: 9px;
		&:hover {
			cursor: pointer;
		}
	}
}
</style>
